export default __webpack_public_path__ + "static/RunRight1-763d0f854ecb904c6d5e5a1228329d7b.mp3";